import { toDate as a } from "./toDate.js";
function e(t) {
  return a(t).getDay() === 6;
}
export {
  e as default,
  e as isSaturday
};
//# sourceMappingURL=isSaturday.js.map
